import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    fallbackLng: "vi",
    debug: true,
    lng: window.localStorage.getItem("language") ? window.localStorage.getItem("language") : 'vi',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export const changeLanguageHandler = (lang) => {
  window.localStorage.setItem("language", lang);
  i18n.changeLanguage(lang);
};
export default i18n;